"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import type { Swiper as SwiperType } from "swiper";

import "swiper/css";
import "swiper/css/navigation";

import { useRef } from "react";
import ImageWithBasePath from "@/components/image-with-base-path";

const TestimonialsSection = () => {
  const swiperRef = useRef<SwiperType | null>(null);

  return (
    <>
      {/* Testimonials Section Start */}
      <section className="testimonial-section-fourteen section">
        <div className="container">
          <div
            className="section-header section-header-fourteen text-center wow fadeInUp"
            data-wow-duration="1s"
          >
            <h2 className="section-title">
              Words of <span className="section-line">Appreciation</span>{" "}
              <span className="subtitle">from our Customers</span>
            </h2>
          </div>

          {/* Swiper Slider */}
          <Swiper
            modules={[Navigation]}
            loop={true}
            speed={2000}
            spaceBetween={24}
            slidesPerView={3}
            onSwiper={(swiper) => (swiperRef.current = swiper)}
            breakpoints={{
              0: {
                slidesPerView: 1,
              },
              768: {
                slidesPerView: 2,
              },
              992: {
                slidesPerView: 3,
              },
            }}
            className="testimonial-slider-fourteen"
          >
            {/* Slide 1 */}
            <SwiperSlide>
              <div className="testimonial-item-fourteen">
                <div className="testimonial-user">
                  <ImageWithBasePath
                    src="assets/img/reviews/author-6.jpg"
                    alt="Carolyn Ross"
                    className="img-fluid"
                  />
                </div>
                <div className="rating">
                  <i className="fas fa-star filled" />
                  <i className="fas fa-star filled" />
                  <i className="fas fa-star filled" />
                  <i className="fas fa-star filled" />
                  <i className="fas fa-star filled" />
                </div>
                <p className="description">
                  I saw rapid improvements in my skin after just a few sessions.
                  The staff at Clear Skin Dermatology were very professional and
                  helpful. I highly recommend!
                </p>
                <div className="author-info">
                  <h3 className="custom-title">Carolyn Ross</h3>
                  <p className="mb-0">Orlando, Florida</p>
                </div>
              </div>
            </SwiperSlide>

            {/* Slide 2 */}
            <SwiperSlide>
              <div className="testimonial-item-fourteen">
                <div className="testimonial-user">
                  <ImageWithBasePath
                    src="assets/img/reviews/author-7.jpg"
                    alt="Jamie Aurora"
                    className="img-fluid"
                  />
                </div>
                <div className="rating">
                  <i className="fas fa-star filled" />
                  <i className="fas fa-star filled" />
                  <i className="fas fa-star filled" />
                  <i className="fas fa-star filled" />
                  <i className="fas fa-star filled" />
                </div>
                <p className="description">
                                   The staff at Emerald Coast Dermatology are friendly and knowledgeable. They helped me create a skincare routine that has transformed my skin. I'm so grateful!
                </p>
                <div className="author-info">
                  <h3 className="custom-title">Jamie Aurora</h3>
                  <p className="mb-0">Lyon, France</p>
                </div>
              </div>
            </SwiperSlide>

            {/* Slide 3 */}
            <SwiperSlide>
              <div className="testimonial-item-fourteen">
                <div className="testimonial-user">
                  <ImageWithBasePath
                    src="assets/img/reviews/author-8.jpg"
                    alt="Evelyn Reed"
                    className="img-fluid"
                  />
                </div>
                <div className="rating">
                  <i className="fas fa-star filled" />
                  <i className="fas fa-star filled" />
                  <i className="fas fa-star filled" />
                  <i className="fas fa-star filled" />
                  <i className="fas fa-star filled" />
                </div>
                <p className="description">
                  After struggling with acne for years, the team at Radiant Dermatology helped me find a solution that actually works. My skin is now clear and healthy. Thank you!
                </p>
                <div className="author-info">
                  <h3 className="custom-title">Evelyn Reed</h3>
                  <p className="mb-0">Berlin, Germany</p>
                </div>
              </div>
            </SwiperSlide>

            {/* Slide 4 */}
            <SwiperSlide>
              <div className="testimonial-item-fourteen">
                <div className="testimonial-user">
                  <ImageWithBasePath
                    src="assets/img/reviews/author-9.jpg"
                    alt="James Porter"
                    className="img-fluid"
                  />
                </div>
                <div className="rating">
                  <i className="fas fa-star filled" />
                  <i className="fas fa-star filled" />
                  <i className="fas fa-star filled" />
                  <i className="fas fa-star filled" />
                  <i className="fas fa-star filled" />
                </div>
                <p className="description">
                  The clinic provided thorough consultation and effective treatments that noticeably enhanced my complexion. Friendly team and a welcoming atmosphere made.
                </p>
                <div className="author-info">
                  <h3 className="custom-title">James Porter</h3>
                  <p className="mb-0">Seattle, Washington</p>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>

          {/* Custom Navigation */}
          <div className="slide-nav view-all">
            <button
              type="button"
              className="slick-arrow testimonial-prev"
              onClick={() => swiperRef.current?.slidePrev()}
            >
              <i className="isax isax-arrow-left" />
            </button>

            <button
              type="button"
              className="slick-arrow testimonial-next"
              onClick={() => swiperRef.current?.slideNext()}
            >
              <i className="isax isax-arrow-right-1" />
            </button>
          </div>
        </div>

        <ImageWithBasePath
          src="assets/img/bg/testimonial-bg-06.png"
          alt="bg"
          className="testimonial-bg img-fluid"
        />
      </section>
      {/* Testimonials Section End */}
    </>
  );
};

export default TestimonialsSection;